import { createSlice } from "@reduxjs/toolkit";

export const oneOnOneFiltersSlice = createSlice({
    name: 'oneOnOneFilters',
    initialState: {
        filters: {
            lotId: { value: null },
            formatedMeetingDate: { value: null },
        },
    },
    reducers: {
        setFilters: (state, action) => {
            state.filters = action.payload;
        }
    },
});

export const { setFilters } = oneOnOneFiltersSlice.actions;
export default oneOnOneFiltersSlice.reducer;
